import React from "react";
// import { ToastContainer } from "react-toastify";
import Home from "../Pages/Home";
import { Route, Routes } from "react-router-dom";
import Login from "../Pages/Login";
import TripDetails from "../Pages/TripDetails";
import ViewTrip from "../Pages/ViewTrip";
import SaveAddress from "../Pages/SaveAddress";
import EmployeeRequest from "../Pages/EmployeeRequest";
import BranchDetails from "../Pages/BranchDetails";
import Account from "../Pages/Account";
import TripTracking from "../Pages/TripTracking";
import Dashboard from "../Pages/Dashboard";


const routes = () => {
  return (
    <>
      
        {/* <Loader /> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/trip-details" element={<TripDetails />} />
         <Route path="/trip/:tripId" element={<ViewTrip />} />
         <Route path="/track/:tripId" element={<TripTracking />} />
         <Route path="/save-address" element={<SaveAddress />} />
         <Route path="/employee-request" element={<EmployeeRequest />} />
         <Route path="/branch-details" element={<BranchDetails />} />
         <Route path="/account" element={<Account />} />
         <Route path="/dashboard" element={<Dashboard />} />
          
          
        </Routes>
        {/* <ToastContainer /> */}
      
    </>
  );
};

export default routes;
